/** User-facing label for Circatron pack pipe (API values unchanged). */
export function circatronPipeLabel(pipe) {
  switch (pipe) {
    case "incoming":
      return "Channel webhooks";
    case "outbound":
      return "Event webhooks";
    case "hard_inbound":
      return "Apps";
    default:
      return pipe || "";
  }
}
